// extracted by mini-css-extract-plugin
export default {"heading":"case-module--heading--3JewR","headingContainer":"case-module--heading-container--3Kisq","title":"case-module--title--29QfM"};